module.exports = __webpack_public_path__ + "media/images/arrows/right-490d04802e010b1a2dd9b499ed2166b8.svg";